"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_env_scopes_1 = __importDefault(require("../enums/model-env-scopes"));
const model_scopes_1 = __importDefault(require("../enums/model-scopes"));
const GraphandFieldBoolean_1 = __importDefault(require("../lib/fields/GraphandFieldBoolean"));
const GraphandFieldJSON_1 = __importDefault(require("../lib/fields/GraphandFieldJSON"));
const GraphandFieldText_1 = __importDefault(require("../lib/fields/GraphandFieldText"));
const GraphandModel_1 = __importDefault(require("../lib/GraphandModel"));
/**
 * @class DataModel
 * @augments GraphandModel
 * @classdesc DataModel model. Use {@link GraphandGraphandClient#getModel client.getModel("DataModel")} to use this model
 */
class DataModel extends GraphandModel_1.default {
}
DataModel._customFields = {};
DataModel.apiIdentifier = "data-models";
DataModel.baseUrl = "/data-models";
DataModel.scope = model_scopes_1.default.DataModel;
DataModel.envScope = model_env_scopes_1.default.ENV;
DataModel.schema = {
    name: new GraphandFieldText_1.default(),
    slug: new GraphandFieldText_1.default(),
    multiple: new GraphandFieldBoolean_1.default({ defaultValue: true }),
    configuration: new GraphandFieldJSON_1.default(),
};
DataModel.hook("postCreate", (inserted, e) => {
    if (e) {
        return;
    }
    const clients = new Set();
    inserted.forEach((p) => clients.add(p._model._client));
    clients.forEach((client) => {
        const [Module] = client.getModels(["Module"]);
        Module.reinit();
    });
});
DataModel.hook("postDelete", (e, { payload }) => {
    if (e) {
        return;
    }
    const clients = new Set();
    if (Array.isArray(payload)) {
        payload.forEach((p) => clients.add(p.constructor._client));
    }
    else {
        clients.add(payload.constructor._client);
    }
    clients.forEach((client) => {
        const [DataField, Module] = client.getModels(["DataField", "Module"]);
        DataField.reinit();
        Module.reinit();
    });
});
exports.default = DataModel;
